requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      loadError: false,
      loadRequestId: 0,
      productPageUrl: '',
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",
      focusOpener: null,
      focusContainer: null,
      focusHandler: null,
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, showQTYSelector, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el, optionId) {
        this.buttonQuickView = el;
        const requestId = ++this.loadRequestId;
        const variant = document.getElementById('current-variant-' + optionId)?.innerText?.trim();
        this.productPageUrl = variant ? `${url}?variant=${encodeURIComponent(variant)}` : url;
        const productUrl = `${this.productPageUrl}${variant ? '&' : '?'}section_id=${this.sectionId}`;
        this.loading = true;
        this.loadError = false;
        const destination = document.getElementById('quickview-product-content');
        if (destination) destination.innerHTML = '';

        requestAnimationFrame(() => {
          setTimeout(() => {
            if (requestId !== this.loadRequestId) return;
            const display = (content) => {
              if (requestId !== this.loadRequestId) return;
              const target = document.getElementById('quickview-product-content');
              if (target) target.innerHTML = content;
            };
            if (this.cachedResults[productUrl]) {
              display(this.cachedResults[productUrl]);
              this.loading = false;
              return;
            }
            if (!this.cachedfetch[productUrl]) {
              this.cachedfetch[productUrl] = fetch(productUrl)
                .then(response => {
                  if (!response.ok) throw new Error('Quickview request failed');
                  return response.text();
                })
                .then(response => {
                  const source = new DOMParser().parseFromString(response, 'text/html').getElementById('quickview-product-content');
                  if (!source || !source.innerHTML.trim()) throw new Error('Quickview content missing');
                  this.cachedResults[productUrl] = source.innerHTML;
                  return source.innerHTML;
                })
                .finally(() => { delete this.cachedfetch[productUrl]; });
            }
            this.cachedfetch[productUrl]
              .then(display)
              .catch(() => {
                if (requestId === this.loadRequestId) this.loadError = true;
              })
              .finally(() => {
                if (requestId === this.loadRequestId) this.loading = false;
              });
          }, 0);
        });
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => { 
          const getVariant = document.getElementById('current-variant-' + optionId)?.innerText?.trim();
          let urlProduct = `${url}?section_id=choose-option&page=${index}${getVariant ? `&variant=${encodeURIComponent(getVariant)}` : ''}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            if (window.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');  
              }
              if (destinationElm) {
                if (destinationElm.querySelector(".add_to_cart_button")) {
                  destinationElm.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElm.querySelector(".label-btn-quickview")) {
                  destinationElm.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            } else {
              if (destinationElmMobile && (destinationElmMobile.dataset.chooseOptionsUrl !== urlProduct || !destinationElmMobile.querySelector('.choose-options-content'))) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile.dataset.chooseOptionsUrl = urlProduct;
                destinationElm && (destinationElm.innerHTML = '');
              }
              if (destinationElmMobile) {
                if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                  destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                  destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => response.text()).then((content) => {
                const parser = new DOMParser();
                const source = parser.parseFromString(content, 'text/html').getElementById("choose-options-content");
                const parsedContent = source ? source.innerHTML : '';
                
                if (parsedContent) {
                  if (window.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    if (destinationElmMobile) destinationElmMobile.dataset.chooseOptionsUrl = urlProduct;
                    destinationElm && (destinationElm.innerHTML = '');
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);  
                if (window.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }      
              });
            }
            this.loadingChooseOption = false;
          } catch (error) {
            this.loadingChooseOption = false;
          }
        }, 0)
      },
      open(isMiniCart = false) {
        if (!this.show) this.focusOpener = this.buttonQuickView || document.activeElement;
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
      },
      close() {
        if (!this.show) return;
        this.show = false;
        this.removeFocusQuickView();
        this.buttonQuickView = '';
        if (!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },
      canFocus(element) {
        return element?.isConnected && !element.matches(':disabled') &&
          !element.closest('[inert], [hidden]') && element.getClientRects().length > 0 &&
          getComputedStyle(element).visibility !== 'hidden';
      },
      focusQuickView(quickView, btnClose) {
        if (!this.show || this.selected) return;
        const container = document.getElementById(quickView);
        const closeButton = document.getElementById(btnClose);
        if (!container || !this.canFocus(closeButton) || this.focusContainer === container) return;
        const modal = closeButton.closest('[role="dialog"]');
        this.removeFocusQuickView(false);
        this.focusContainer = container;
        this.focusHandler = (event) => {
          if (!this.show || this.selected || event.target.closest('[role="dialog"]') !== modal) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.close();
          } else if (event.key === 'Tab') {
            const elements = Array.from(modal.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'))
              .filter(element => element.tabIndex >= 0 && this.canFocus(element) && element.closest('[role="dialog"]') === modal);
            const first = elements[0] || closeButton;
            const last = elements[elements.length - 1] || closeButton;
            if (event.shiftKey && event.target === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && event.target === last) {
              event.preventDefault();
              first.focus();
            }
          }
        };
        container.addEventListener('keydown', this.focusHandler);
        closeButton.focus();
      },
      removeFocusQuickView(restoreFocus = true) {
        if (this.focusContainer && this.focusHandler) {
          this.focusContainer.removeEventListener('keydown', this.focusHandler);
        }
        this.focusContainer = null;
        this.focusHandler = null;
        if (restoreFocus) {
          const opener = this.canFocus(this.focusOpener) ? this.focusOpener : document.getElementById('MainContent');
          this.focusOpener = null;
          if (this.canFocus(opener)) opener.focus();
        }
      },
      focusChooseOptions() {
        if (!this.openPopupMobile || !this.chooseOptionOpener) return;
        const mobile = window.innerWidth < 768;
        const content = mobile ? document.getElementById('choose-options-mobile') : document.getElementById('choose-options-' + this.chooseOptionId);
        if (!content?.querySelector('.choose-options-content')) return;
        const panel = mobile ? content.closest('[role="dialog"]') : content;
        const closeButton = panel?.querySelector(mobile ? '.group-close-btn' : '.js-close-button');
        if (!panel || !this.canFocus(closeButton) || this.chooseOptionPanel === panel) return;
        this.removeChooseOptionsFocus(false);
        this.chooseOptionPanel = panel;
        this.chooseOptionKeyHandler = (event) => {
          if (!this.openPopupMobile) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            closeButton.click();
          } else if (mobile && event.key === 'Tab') {
            const elements = Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'))
              .filter(element => element.tabIndex >= 0 && this.canFocus(element));
            const first = elements[0] || closeButton;
            const last = elements[elements.length - 1] || closeButton;
            if (event.shiftKey && event.target === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && event.target === last) {
              event.preventDefault();
              first.focus();
            }
          }
        };
        panel.addEventListener('keydown', this.chooseOptionKeyHandler);
        closeButton.focus();
      },
      removeChooseOptionsFocus(restoreFocus = true) {
        if (this.chooseOptionPanel && this.chooseOptionKeyHandler) {
          this.chooseOptionPanel.removeEventListener('keydown', this.chooseOptionKeyHandler);
        }
        this.chooseOptionPanel = null;
        this.chooseOptionKeyHandler = null;
        if (restoreFocus) {
          const opener = this.canFocus(this.chooseOptionOpener) ? this.chooseOptionOpener : document.getElementById('MainContent');
          this.chooseOptionOpener = null;
          if (this.canFocus(opener)) opener.focus();
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
        this.removeChooseOptionsFocus();
      },
      showChooseOption(id, el) {
        this.removeChooseOptionsFocus(false);
        this.chooseOptionOpener = el;
        this.chooseOptionId = id;
        this.openPopupMobile = true;
        Alpine.nextTick(() => this.focusChooseOptions());
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }       
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart && this.show) {
          evt.stopPropagation();
          this.show = false;
          this.removeFocusQuickView();
          this.buttonQuickView = '';
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });
  });
});
